import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MainURL } from '../constants/configUrl';
import { hrtime } from 'process';

@Injectable({
  providedIn: 'root'
})
export class HttpmethodsService {

  baseUrl = MainURL.HostUrl;
  constructor(private http : HttpClient) { 
  }

  

  postRequestPublic(url,body)
  {
   return this.http.post(this.baseUrl+url,body)
  }

  postRequest(url,body)
  {
   return this.http.post(this.baseUrl+url,body)
  }

  getRequest(url){
    return this.http.get(this.baseUrl+url)
  }

  putRequest(url,body){
    return this.http.put(this.baseUrl+url,body)
  }

  deleteRequest(url,id){
    return this.http.delete(this.baseUrl+url+"/"+id)
  }

  // public fileUpload(url:  string,formData: File)
  // {
  //   const uploadfile: FormData = new FormData();  
  
  //   uploadfile.append('uploadfile', formData);  
   
  //   return this.http.post(this.baseUrl+url, uploadfile);
  //  }


   public fileUpload(url:  string,formData: File)
  {
    const uploadfile: FormData = new FormData();  
    uploadfile.append('file', formData); 
    return this.http.post(this.baseUrl+url, uploadfile);
   }

   postRequestJasper(url,body) 
   {
    return this.http.post(this.baseUrl+url,body,{responseType: 'arraybuffer'})
   }

  getRequestJasper(url)
  {
     return this.http.get(this.baseUrl+url,{responseType:"arraybuffer"})
  }

  getPrivilegeJson(){
    return {
      "roleSettingRead":false,
    "roleSettingWrite":false,

    "courseSettingRead":false,
    "courseSettingWrite":false,

    "followupSettingRead":false,
    "followupSettingWrite":false,

    "paymentSettingRead":false,
    "paymentSettingWrite":false,

    "sourceOfLeadSettingRead":false,
    "sourceOfLeadSettingWrite":false,

    "expenseSettingRead":false,
    "expenseSettingWrite":false,

    "classSettingRead":false,
    "classSettingWrite":false,

    "branchSettingRead":false,
    "branchSettingWrite":false,

    "staffSettingRead":false,
    "staffSettingWrite":false,

    "privilegeSettingRead":false,
    "privilegeSettingWrite":false,

    "batchSettingRead":false,
    "batchSettingWrite":false,

    "expenseCategorySettingRead": false,
    "expenseCategorySettingWrite": false,

    "dashboardFullAccess":false,
    
    "leadDisplyShowWithoutAdmin":false,

    "admissionDisplyShowWithoutAdmin": false,

    "generateExpense": false,
    
    "performanceReportRead": false,
    "performanceReportFullAccess": false,

    "expenseReportRead": false,
    "expenseReportFullAccess": false,
      
    "followupCallReport": false,
    "followupCallReportFullAccess": false,
      
    "installmentViewReport": false,
    "installmentViewReportFullAccess": false,

    "leadaAndAdmissionTransferredReport":false,
    "leadaAndAdmissionTransferredReportFullAccess":false,
      
    "notificationTodayFollowupCall": false,
    "notificationPendingFollowupCall": false,
    "notificationLeadTransfer": false,
    "notificationTodayFeeCall": false,
    "notificationPendingFeeCall": false
    }
  }


}
